import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="jgGk1vw9UYM"
                    title="Overview over InstarVision's function buttons"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="Overview over InstarVision's function buttons"
              footer={
                <EuiText>
                <p>Schaltflächen in der iPhone App InstarVision.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}


// import React from 'react'

// import { Player } from 'video-react'

// import {
//     EuiTitle,
//     EuiText,
//     EuiIcon,
//     EuiPanel
//   } from '@elastic/eui'

// import { OutboundLink } from 'gatsby-plugin-gtag'

// require('../../../../Layout/chrome/assets/video.css')

// function VideoCard() {
//   return (
//     <EuiPanel paddingSize="m">
//         <EuiTitle size="s"><h4>Overview over InstarVision's function buttons</h4></EuiTitle>
//         <Player>
//         <source src="https://wiki.instar.com/videos/Anschlusskabel_entfernen_bei_einer_INSTAR_IN5905HD.mp4" />
//         </Player>
//         <EuiText>
//             <p>Schaltflächen in der iPhone App InstarVision. Auf <OutboundLink href="https://www.youtube.com/watch?v=jgGk1vw9UYM" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
//         </EuiText>
//     </EuiPanel>
//   );
// }

// export default VideoCard